import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    template: ''
})
export class CleanupComponent implements OnDestroy {

    sub: Subscription = new Subscription();

    constructor() {

    }

    addSub(subScriptions: Subscription[]) {
        subScriptions.forEach(element => {
            this.sub.add(element);
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
